<template>
    <div class="container-fluid">
        <div class="page-title-sec">
            <h3>Number of Paying Members</h3>
        </div>
        <div class="card mt-3 pt-4">
            <div class="container-fluid">
                <div v-if="payingMembers && payingMembers.length > 0">
                    <list-table :records="payingMembers"></list-table>
                </div>
                <div class="pb-4 text-center" v-else>
                    <p>No records found.</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ListTable from './includes/ListTable'
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'MainPage',
  components: {
    ListTable
  },
  computed: {
    ...mapGetters({
      payingMembers: 'payingMembers/getPayingMembers'
    })
  },
  mounted () {
    this.loadPayingMembers()
  },
  methods: {
    ...mapActions({
      loadPayingMembers: 'payingMembers/loadData'
    })
  }
}
</script>

<style scoped>

</style>
